<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-4">
    <v-expansion-panel-header
      id="rec_doc_ret_guide"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >DOCUMENT RETRIEVAL GUIDE
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <v-card shaped>
        <v-card-title>
          <h4>A Guide to retrieving public records request.</h4>
        </v-card-title>
        <v-card-text>
          <div>
            <a
              class="text-body2 text-sm-h6 text-md-h6 blue--text lighten-1 mt-3"
              href="/retrieve"
              >OneRequest Documents Guide</a
            >
          </div>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
@import "../scss/site.scss";
.letter2_img {
  /* max-width: 877px; */
  width: 100%;
  height: auto;
}
p {
  font-weight: 600;
  padding: 12px;
}
a {
  color: blue;
}
a:visited {
  color: rgb(2, 2, 32);
}
.bcs-expansion-content {
  color: black;
}
.bcs-expansion-content {
  color: black;
}
.basic-interior-card {
  min-height: 100px;
}
.div-login-page-img {
  margin: 0;
}
.login-page-img {
  width: 100%;
  height: auto;
  margin-left: 0 !important;
}
@media (min-width: 768px) {
  .login-page-img {
    max-width: 300px;
  }
  .letter2_img {
    /* max-width: 877px; */
    width: 80%;
    height: auto;
  }
  .img_100_per {
    /* max-width: 877px; */
    width: 100%;
    height: auto;
  }
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "doc_ret_guide",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
